export const augustAbbreviatedLowercase = "Tqa";
export default {augustAbbreviatedLowercase};